import { memo, useCallback, useMemo } from "react";


import type { DayOfTheWeek } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { CheckboxGroupField } from "@/components/ui/form/fields/check-box-field/check-box-group";

import * as Constants from "./constants";
import { FormFieldLayout } from "../../layouts";

import type { CheckedState } from "@radix-ui/react-checkbox";

type Props = {
	// 利用可能曜日
	stayableDayOfTheWeek: Array<DayOfTheWeek>;

	// 利用可能曜日の変更
	onChangeStayableDayOfTheWeek: (value: DayOfTheWeek) => void;
};

export const StayableDayOfTheWeekFormFieldComposition = memo(
	({ stayableDayOfTheWeek, onChangeStayableDayOfTheWeek }: Props) => {
		/**
		 * 利用可能曜日の変更
		 */
		const handleChangeStayableDayOfTheWeek = useCallback(
			(_: CheckedState, item: FormOptionType) => {
				onChangeStayableDayOfTheWeek(item.value as DayOfTheWeek);
			},
			[onChangeStayableDayOfTheWeek],
		);

		/**
		 * ViewModel でエラーを保持しないようにしている
		 * 利用可能な曜日の場合、配列の要素全体に対してバリデーションを行うため、現行の ViewModel ではカバーすることができない
		 */
		const hasError = useMemo(() => stayableDayOfTheWeek.length === 0, [stayableDayOfTheWeek.length]);

		return (
			<FormFieldLayout title="利用可能な曜日">
				<CheckboxGroupField
					value={stayableDayOfTheWeek}
					options={Constants.StayableDayOfTheWeekOptions}
					handleCheckedChange={handleChangeStayableDayOfTheWeek}
					gridCols={2}
					errorMessage={hasError ? "利用可能な曜日は必須項目です" : undefined}
				/>

				<div className="mt-2">
					<p className="whitespace-pre-wrap text-sm text-caption-50">
						{`チェックを外すことで特定の曜日のみで利用可能なディスカウントにすることが可能です。\nチェックをされた曜日にチェックインの予約でこのディスカウントがご利用可能です。`}
					</p>
				</div>
			</FormFieldLayout>
		);
	},
);
